var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5H8.5ZM8 8H7.5C7.5 8.27614 7.72386 8.5 8 8.5V8ZM11.5 8.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5V8.5ZM13.5 8C13.5 11.0376 11.0376 13.5 8 13.5V14.5C11.5899 14.5 14.5 11.5899 14.5 8H13.5ZM8 13.5C4.96243 13.5 2.5 11.0376 2.5 8H1.5C1.5 11.5899 4.41015 14.5 8 14.5V13.5ZM2.5 8C2.5 4.96243 4.96243 2.5 8 2.5V1.5C4.41015 1.5 1.5 4.41015 1.5 8H2.5ZM8 2.5C11.0376 2.5 13.5 4.96243 13.5 8H14.5C14.5 4.41015 11.5899 1.5 8 1.5V2.5ZM7.5 4.5V8H8.5V4.5H7.5ZM8 8.5H11.5V7.5H8V8.5Z",
    fill: "#111111",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.95901989009cc8b17a0d6627adf3801f.svg";
export { ForwardRef as ReactComponent };